import { jsx as _jsx } from "react/jsx-runtime";
import { typographyClasses } from '@mui/material';
import { TypographyStyled } from './Typography.styled';
const Typography = (props) => {
    return _jsx(TypographyStyled, { ...props });
};
export { Typography, typographyClasses };
